import { getLogger } from "@expert/logging";
import type { ContentfulClientApi, EntryFieldTypes, EntrySkeletonType } from "contentful";

export interface PersonalizeCoverageResponse {
    deviceName: string;
    examples: string[];
}

interface ExamplesData {
    generic: string[];
    [key: string]: string[];
}

interface PersonalizeCoverageFields {
    deviceName: EntryFieldTypes.Symbol;
    examples: EntryFieldTypes.Object;
}

const logger = getLogger({
    module: "personalize-coverage",
    supportTeam: "sales",
});

export const getPersonalizeCoverageExamples = async (
    contentfulClient: ContentfulClientApi<undefined>,
    productSku?: string,
): Promise<PersonalizeCoverageResponse[]> => {
    try {
        const entries = await contentfulClient.withoutUnresolvableLinks.getEntries<
            EntrySkeletonType<PersonalizeCoverageFields>
        >({
            content_type: "personalizeCoverage",
        });

        if (!entries.items.length) {
            logger.warn("No personalizeCoverage entries found.");
            return [];
        }

        return entries.items.map((entry) => {
            const { deviceName, examples } = entry.fields;
            const exampleData = examples as ExamplesData;

            const partnerExamples =
                productSku && Array.isArray(exampleData[productSku]) ? exampleData[productSku] : exampleData["generic"];

            return {
                deviceName,
                examples: partnerExamples,
            };
        });
    } catch (error) {
        logger.error({ error }, "Error fetching personalize coverage examples:");
        return [];
    }
};
